import AttributesLoader from 'components/PageLayout/AttributesLoader';
import hostingDetailsAlsowith from 'pages/servers/details/hostingDetailsAlsowith';
import useAssetDetails from 'modules/queries/asset/useDetails';
import { useLatestNotifications } from 'modules/queries/notification/useCurrent';
import { useParams } from 'react-router';
import AttributesContent from './AttributesContent';

interface AttributesProps {
	isLocationEnabled?: boolean;
	refetchInterval?: number;
	/** prefer displaying `ip` instead of `domain` */
	showIp?: boolean;
	/** override what would normally be displayed in the displayType attribute */
	displayType?: string;
	showStatusBadge?: boolean;
}

const Attributes = ({
	isLocationEnabled,
	refetchInterval,
	displayType: displayTypeProp,
	showIp,
	showStatusBadge = true,
}: AttributesProps) => {
	const { uniqId } = useParams<{ uniqId: string }>();
	const { data, isLoading, isError } = useAssetDetails(
		{
			alsowith: hostingDetailsAlsowith,
			uniq_id: uniqId,
		},
		{ enabled: Boolean(uniqId), refetchInterval },
	);

	const { data: notifications, isLoading: isLoadingNotifications } =
		useLatestNotifications(
			{},
			{
				refetchInterval: 10000,
				enabled: Boolean(uniqId),
			},
		);

	if (isError) {
		return null;
	}

	if (isLoading || isLoadingNotifications) {
		return <AttributesLoader />;
	}

	const { displayType, ...rest } = data;

	return (
		<AttributesContent
			showLocation={isLocationEnabled}
			notification={notifications?.[uniqId]}
			displayType={displayTypeProp || displayType}
			showIp={showIp}
			showStatusBadge={showStatusBadge}
			{...rest}
		/>
	);
};

export default Attributes;
